// extracted by mini-css-extract-plugin
export var active = "_8v-d";
export var blink = "_8v-e";
export var container = "_8v-5";
export var controls = "_8v-0";
export var controlsRight = "_8v-1";
export var fakeCursor = "_8v-c";
export var hidden = "_8v-b";
export var quillContainerSmall = "_8v-7";
export var quillEditor = "_8v-6";
export var quillEditorSmall = "_8v-8";
export var quillFormatButtons = "_8v-a";
export var quillToolbar = "_8v-9";
export var removePadding = "_8v-2";
export var state = "_8v-3";
export var stateTitle = "_8v-4";